module.exports = __webpack_public_path__ + "static/img/Mosaic-Default.4df7148.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Mosaic-Default.png
// module id = 1578
// module chunks = 0